/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React, { useRef } from 'react';
import Lottie, { LottieRefCurrentProps } from 'lottie-react'
import WMGLogo from 'assets/animatedIcons/loadMoreLogo.json'

const Loading: React.FC = () => {
  const lottieRef = useRef<LottieRefCurrentProps | null>(null)
  return (
    <div id={'spinner-container'} style={{
      height: '100vh',
      width: '100vw',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <Lottie lottieRef={lottieRef} animationData={WMGLogo} loop={true} style={{
        aspectRatio: '650/320',
        maxWidth: 200,
      }}
      />
    </div>

  )
};

export default Loading;
